import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { X, Users, Check } from 'lucide-react';
import { getModuleWorkstreams } from '../../config/moduleHelpers';

const BulkAssignModal = ({ selectedClients, staffList, config, onAssign, onClose }) => {
  const [selectedStaff, setSelectedStaff] = useState('');
  const [selectedWorkstream, setSelectedWorkstream] = useState('');
  const workstreams = getModuleWorkstreams(config);

  const handleAssign = () => {
    if (selectedStaff && selectedWorkstream) {
      onAssign(selectedWorkstream, selectedStaff);
      onClose();
    }
  };

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-6 border-b border-slate-200">
          <div className="flex items-center gap-3">
            <Users className="w-6 h-6 text-blue-600" />
            <h3 className="text-lg font-semibold text-slate-800">Bulk Assign Staff</h3>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-sm text-slate-600">
            Assign {selectedClients.length} selected client{selectedClients.length !== 1 ? 's' : ''} to a staff member.
          </p>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Workstream</label>
            <select
              value={selectedWorkstream}
              onChange={(e) => setSelectedWorkstream(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded-md bg-white text-slate-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              style={{ colorScheme: 'light' }}
            >
              <option value="" className="bg-white text-slate-800">Select workstream...</option>
              {workstreams.filter(ws => ws.staffField).map(ws => (
                <option key={ws.key} value={ws.key} className="bg-white text-slate-800">{ws.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Staff Member</label>
            <select
              value={selectedStaff}
              onChange={(e) => setSelectedStaff(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded-md bg-white text-slate-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              style={{ colorScheme: 'light' }}
            >
              <option value="" className="bg-white text-slate-800">Select staff member...</option>
              {staffList.map(staff => (
                <option key={staff.id} value={staff.id} className="bg-white text-slate-800">{staff.name}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-6 border-t border-slate-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-md hover:bg-slate-50"
          >
            Cancel
          </button>
          <button
            onClick={handleAssign}
            disabled={!selectedStaff || !selectedWorkstream}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            <Check className="w-4 h-4" />
            Assign
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default BulkAssignModal;